import React, { Component } from 'react';

class IconTopbarLogout extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="none"
                viewBox="0 0 25 25"
            >
                <path
                    fill="#26A"
                    d="M5.829 22.5c-.751 0-1.471-.264-2.002-.733-.53-.47-.829-1.107-.829-1.771V5.004c0-.664.298-1.3.83-1.77.53-.47 1.25-.734 2-.734h7.549c.75 0 1.47.264 2.001.733.531.47.83 1.107.83 1.771v1.444a.79.79 0 01-.277.59 1.01 1.01 0 01-.667.245c-.25 0-.49-.088-.667-.244a.789.789 0 01-.277-.59V5.003c0-.221-.099-.434-.276-.59a1.01 1.01 0 00-.667-.245H5.829c-.25 0-.49.088-.668.245a.79.79 0 00-.276.59v14.992c0 .221.1.434.276.59.177.157.417.245.668.245h7.548c.25 0 .49-.088.667-.245a.789.789 0 00.276-.59v-1.444c0-.222.1-.434.277-.59.177-.157.417-.245.667-.245.25 0 .49.088.667.245a.789.789 0 01.276.59v1.444c0 .664-.298 1.3-.829 1.77-.53.47-1.25.734-2.001.734H5.829zm10.678-5.69a1.003 1.003 0 01-.246-.325.902.902 0 010-.768c.057-.122.14-.232.247-.325l2.156-1.909h-8.118a1.219 1.219 0 01-.798-.295.954.954 0 01-.334-.706c0-.266.12-.52.332-.709.212-.188.5-.293.8-.293h8.115l-2.118-1.874a.993.993 0 01-.244-.324.894.894 0 01-.084-.382c0-.198.066-.392.19-.557.124-.164.3-.293.508-.369a1.27 1.27 0 01.653-.058c.22.039.422.134.58.274l4.852 4.292-4.891 4.326c-.105.093-.23.166-.366.216-.137.05-.284.076-.433.075-.3.001-.587-.102-.8-.288z"
                ></path>
            </svg>
        );
    }
}

export default IconTopbarLogout;